const teamData = [
  {
    img: "/assets/images/our-team/AMNAS.png",
    name: "AMNAS AHMED",
    position: "OPERATIONS MANAGER",
    socials: [
      { icon: "fab fa-facebook-f", link: "https://facebook.com/amnas" },
      { icon: "fab fa-twitter", link: "https://twitter.com/amnas" },
      { icon: "fab fa-instagram", link: "https://instagram.com/amnas" },
      { icon: "fab fa-linkedin-in", link: "https://linkedin.com/in/amnas" }
    ]
  },
  {
    img: "/assets/images/our-team/ARSHAD.png",
    name: "ARSHAD AHAMMAD",
    position: "BUSINESS DEVELOPMENT MANAGER",
    socials: [
      { icon: "fab fa-facebook-f", link: "https://facebook.com/arshad" },
      { icon: "fab fa-twitter", link: "https://twitter.com/arshad" },
      { icon: "fab fa-instagram", link: "https://instagram.com/arshad" },
      { icon: "fab fa-linkedin-in", link: "https://linkedin.com/in/arshad" }
    ]
  },
  {
    img: "/assets/images/our-team/SADI.png",
    name: "MOHAMMED SADIQUE",
    position: "HR MANAGER",
    socials: [
      { icon: "fab fa-facebook-f", link: "https://facebook.com/sadique" },
      { icon: "fab fa-twitter", link: "https://twitter.com/sadique" },
      { icon: "fab fa-instagram", link: "https://instagram.com/sadique" },
      { icon: "fab fa-linkedin-in", link: "https://linkedin.com/in/sadique" }
    ]
  },
  {
    img: "/assets/images/our-team/RAMIZ.png",
    name: "RAMIZ AHMED",
    position: "MANAGING DIRECTOR",
    socials: [
      { icon: "fab fa-facebook-f", link: "https://facebook.com/ramiz" },
      { icon: "fab fa-x-twitter", link: "https://twitter.com/ramiz" },
      { icon: "fab fa-instagram", link: "https://instagram.com/ramiz" },
      { icon: "fab fa-linkedin-in", link: "https://linkedin.com/in/ramiz" }
    ]
  }
];

export default teamData;
